import React, { Component } from "react"
import "gsap"

export default class extends Component {
  componentDidMount() {
    const clouds = this.el.querySelectorAll("#china-clouds path")

    this.animation = new TimelineMax().staggerTo(
      clouds,
      15,
      {
        x: 800,
        repeat: -1,
        ease: Power0.easeNone
      },
      4
    )

    this.animation.paused(!this.props.isActive)
  }

  componentWillReceiveProps(nextProps) {
    this.animation.paused(!nextProps.isActive)
  }

  render() {
    return (
      <svg ref={el => (this.el = el)} viewBox="2 120.89 600 600">
        <clipPath id="china-clip">
          <path d="M602 420.89c0 165.686-134.314 300-300 300S2 586.576 2 420.89c0-165.685 134.314-300 300-300s300 134.315 300 300" />
        </clipPath>
        <g clipPath="url(#china-clip)">
          <path d="M-2.97 115.193h611.11v323.232H-2.97z" fill="#BBDEFB" />
          <path
            d="M-22.16 444.49l19.19-14v.71M-2.97 578.17v1.51l-14.34-21.05z"
            fill="#CFA568"
          />
          <path
            d="M333.394 478.922l-43.408-2.1L522.283 376.81h25.252z"
            fill="#A1887F"
          />
          <path
            d="M625 591.89l-16.75 64.72H-2.97v-76.93l-14.34-21.05 14.34 19.54V430.49l81.82-59.68 19.08-9.49 119.526.114z"
            fill="#33691E"
          />
          <path
            d="M203.34 284.89v76.43H97.93L-2.97 431.2v-35.38l81.82-49.99v-15.44h12.33v-45.5h21.59v12.19h8.41v-12.19h21.59v12.19h8.97v-12.19h21.6v12.19h8.4v-12.19z"
            fill="#CFA568"
          />
          <path
            d="M199.705 363.823l-.006-37.967 14.006 16.653h-6.294l9.078 9.628h-8.056l11.41 11.685z"
            fill="#2E5E1B"
          />
          <path
            d="M199.692 363.823l.007-37.967-14.008 16.653h6.294l-9.08 9.628h8.057l-11.41 11.685z"
            fill="#214514"
          />
          <path
            d="M147.257 353.89l35.35 126.038 42.973-18.53-47.532-107.508z"
            fill="#CFA568"
          />
          <path
            d="M608.14 422.69V725.9H-2.97V579.68l-14.34-21.05 14.34 19.54v-32.09l55.28-23.14 13.19-5.52 27.64-11.57 53.48-22.38 53.08-22.22 93.25-39.03 184.89-77.38 59.26 35.41z"
            fill="#558B2F"
          />
          <path
            d="M537.1 372.365h27.607L325.7 478.922l-30.013-2.1z"
            fill="#FFE0B2"
          />
          <path
            d="M608.14 314.17v129.87H537.1l-173.4 79.69v35.4H256.63V456.41H363.7v5.42l173.4-77.17v-70.49h15.32v15.65h4.68v-15.65h15.32v15.65h4.68v-15.65h15.32v15.65h4.68v-15.65z"
            fill="#EBBC76"
          />
          <path
            d="M169.758 540.446L303.09 498.02v60.607L169.76 624.284z"
            fill="#FFCC80"
          />
          <path
            d="M151.5 476.628v66.665H-1.75v-66.665l76.625-50.75z"
            fill="#CFA568"
          />
          <path
            d="M273.798 498.02h29.293L169.76 540.447H135.42z"
            fill="#FFE0B2"
          />
          <path
            d="M176.83 504.98v139.51H-2.97v-64.81l-14.34-21.05 14.34 19.54v-72.88h13.78v27.07h13.18v-27.95h28.32v27.95H65.5v-26.51h28.32v26.51h13.19v-26.51h28.31v26.51h13.19v-27.38z"
            fill="#FFCC80"
          />
          <path d="M309.89 725.9h-93.51l-70.86-85.45v-81.82z" fill="#FFCC80" />
          <path
            d="M71.12 588.425c6.663 0 12.064 5.4 12.064 12.064v34.905H59.056V600.49c0-6.663 5.4-12.065 12.064-12.065z"
            fill="#5D4037"
          />
          <path d="M231.46 725.9H79.7l-58.43-90.5h129.8z" fill="#CFA568" />
          <path
            d="M105.48 725.9H-2.97V579.68l41.85 55.72 6.83 9.09 8.9 12.12z"
            fill="#FFCC80"
          />
          <path
            d="M96.62 725.9l-47.19-69.29-8.26-12.12-6.19-9.09-37.95-55.72v-21.05H9.15l55.3 76.77 6.55 9.09 8.73 12.12 49.91 69.29z"
            fill="#FFE0B2"
          />
          <path d="M145.515 558.627" fill="#6D4C41" />
          <path d="M361.91 725.9h-52.02L145.52 558.63h31.31z" fill="#FFE0B2" />
          <path
            d="M74.05 406.19l-.75.56v-1.12zM74.8 405.63v1.12l-.75-.56z"
            fill="#FFCC80"
          />
          <path
            d="M608.14 658.658h-35.715l35.715 33.21v29.022h-86.91l-.044-202.216 82.163 88.695h-36.923l41.713 40.18zM401.16 530.378l-.01-58.04 21.412 25.458h-9.62l13.877 14.72h-12.316l17.443 17.862z"
            fill="#3F8225"
          />
          <path
            d="M401.14 530.378l.01-58.04-21.413 25.458h9.622l-13.88 14.72h12.316l-17.444 17.862z"
            fill="#33691E"
          />
          <path
            d="M431.958 539.93l-.01-65.39 24.124 28.682h-10.84l15.636 16.584h-13.875l19.653 20.125z"
            fill="#3F8225"
          />
          <path
            d="M431.936 539.93l.01-65.39-24.124 28.682h10.84l-15.636 16.584H416.9l-19.65 20.125z"
            fill="#33691E"
          />
          <path
            d="M608.07 451.35l23.684 24.246v12.96h-51.466l-.027-120.893 44.605 53.035h-20.037l26.926 28.56 1.97 2.092z"
            fill="#3F8225"
          />
          <path
            d="M580.24 488.562l.02-120.895-44.6 53.027h20.04l-28.907 30.662h25.652l-36.333 37.206zM521.15 720.89l.04-202.215-82.156 88.697h36.915l-53.25 51.285h47.252l-66.926 62.233z"
            fill="#33691E"
          />
          <path
            d="M117.306 370.634l-.01-56.464 20.83 24.767h-9.36l13.503 14.32h-11.982l16.97 17.377z"
            fill="#2E5E1B"
          />
          <path
            d="M117.286 370.634l.01-56.464-20.83 24.767h9.36l-13.503 14.32h11.98l-16.968 17.377z"
            fill="#214514"
          />
          <path
            d="M103.222 616.39h24.128v-13.77c0-6.662-5.4-12.063-12.064-12.063-6.663 0-12.064 5.4-12.064 12.064v13.77z"
            fill="#5D4037"
          />
          <path
            d="M199.7 452.14v13.41c-9.53 10.97-27.56 15.66-44.78 17.47-2.78.29-5.55.44-8.3.45-27.13.08-52.88-13.45-67.39-36.75-2.34-3.75-4.18-7.46-5.2-10.95-1.02 3.49-2.86 7.2-5.21 10.95-15.31 24.55-43.09 38.19-71.79 36.52v-23.06c19.88-3.39 38.27-14.05 51.38-30.19l26.07-32.1 25.42 31.89c18.84 23.64 49.03 35.68 78.8 30.44 8.16-1.44 15.62-3.95 21-8.08z"
            fill="#FFCC80"
          />
          <g id="china-clouds">
            <path
              d="M-18.332 224.693c0-12.55-10.866-22.722-24.272-22.722-3.14 0-6.137.565-8.89 1.58-3.655-10.695-13.784-18.39-25.72-18.39-11.952 0-22.094 7.72-25.734 18.442-2.914-1.32-6.146-2.063-9.553-2.063-12.796 0-23.17 10.372-23.17 23.167s10.374 23.168 23.17 23.168c.76 0 1.512-.04 2.254-.11.543.07 1.113.11 1.705.11h64.837c1.445 0 2.774-.228 3.844-.61 12.114-1.275 21.528-10.892 21.528-22.572z"
              fill="#FFF"
            />
            <path
              d="M-27.648 175.805c0-10.556-9.14-19.114-20.417-19.114-2.64 0-5.162.476-7.48 1.33-3.072-8.997-11.594-15.47-21.634-15.47-10.053 0-18.585 6.494-21.646 15.513-2.45-1.11-5.17-1.735-8.036-1.735-10.764 0-19.49 8.726-19.49 19.49s8.727 19.488 19.49 19.488c.64 0 1.272-.033 1.897-.093.457.06.937.094 1.435.094h54.542c1.216 0 2.333-.192 3.233-.513 10.188-1.074 18.107-9.164 18.107-18.99z"
              fill="#FFF"
            />
            <path
              d="M-8.864 293.79c0-14.575-12.62-26.39-28.19-26.39-3.645 0-7.126.655-10.325 1.835-4.242-12.422-16.007-21.358-29.868-21.358-13.88 0-25.66 8.965-29.887 21.418-3.384-1.534-7.138-2.395-11.095-2.395-14.86 0-26.907 12.047-26.907 26.907s12.047 26.907 26.907 26.907c.884 0 1.757-.045 2.62-.13.63.084 1.292.13 1.98.13h75.3c1.68 0 3.223-.265 4.465-.707 14.07-1.484 25-12.653 25-26.218z"
              fill="#FFF"
            />
          </g>
        </g>
      </svg>
    )
  }
}



// WEBPACK FOOTER //
// ./animations/china-wall.js